import { FC } from "react";

export const PrivacyPolicy: FC = () => {
  return (
    <>
      PRIVACY POLICY
    </>
  )
}
